export default __webpack_public_path__ + "static/media/1.269f2697.png";